<div class="modal-header">
    Verifica documenti inviati a SdI
    <div class="card-tools">
        <button type="button" class="btn btn-tool" (click)="cancel()" >
          <i class="fas fa-times"></i>
        </button>
    </div>
</div>
<div class="modal-body" style="max-height:80vh; overflow-y:auto">
    <!-- <div class="my-5 text-center" *ngIf="loading">
        <i class="fas fa-spinner fa-spin fa-2x text-primary mb-2"></i><br>
        <i class="fas fa-cloud-download-alt mr-2"></i>Scaricamento informazioni in corso...<br>La procedura potrebbe impiegare diversi minuti!<br>
        <button type="button" class="btn btn-outline-secondary mt-3" (click)="cancel()" >Annulla</button>
    </div> -->
    <ng-container >
        <div class="row pb-2">
           <div class="col-lg-3"></div>
            <div class="col-lg-6">
                <div class="input-group input-group-sm">
                    <div class="input-group-prepend pr-2">
                        <label>Visualizza documenti ultimi 30 giorni rispetto al:</label>
                    </div>
                    <input type="date" class="form-control form-control-sm" [(ngModel)]="date_search" (change)="getList()">
                    <div class="input-group-append">
                    <!-- <button class="btn btn-default text-primary" title="Cerca" (click)="getList()"><i class="fa fa-search"></i></button> -->
                    <button class="btn btn-default border" title="Cerca indietro" (click)="moveSearch(-30)"><i class="fa fa-arrow-up"></i></button>
                    <button *ngIf="viewButtonSearch()"class="btn btn-default border" title="Cerca avanti" (click)="moveSearch(+30)"><i class="fa fa-arrow-down"></i></button> 
                </div>
                </div>
            </div>
            <div class="col-4">
            </div>
        </div>
        <div *ngIf="!list || list.length==0" class="m-5 text-center text-secondary">
            <i class="icon fas fa-info-circle mr-2"></i><i>Nessuna fattura da visualizzare</i>
        </div>
        <table class="table table-sm table-striped" style="max-height:60vh" *ngIf="list!=null && list.length>0">            
            <thead>
                <th>ID</th>
                <th class="">Num.</th>
                <th class="">Data</th>
                <th class="">Cliente</th>
                <th class="">Importo</th>
                <th class="">Stato SdI</th>
                <th class="">Stato interno</th>
                <th class="text-center" title="Sincronizzato">Sincr.</th>
                <th class="text-right">Identificativo SdI</th>
            </thead>
            <tr *ngFor="let record of list">
                <td class="">
                    <small *ngIf="record.id==0">
                        <i class="text-warning fa fa-exclamation-triangle" title="ID non presente"></i>
                    </small>    
                    <small *ngIf="record.id>0">
                        {{record.id}}
                    </small>
                </td>
                <td class="">{{record.number}}</td>
                <td class="">{{record.date | date:"dd/MM/yyyy"}}</td>
                <td class=""><b>{{record.name}}</b></td>
                <td class="">{{record.total | currency:"EUR"}}</td>               
                <td class="status-{{record.new_status}}">
                    <small *ngIf="record.new_status==1"><i class="text-warning fa fa-clock mr-2"></i>(Inviata)</small>
                    <small *ngIf="record.new_status==2"><i class="text-success fa fa-check mr-2"></i>(Consegnata)</small>
                    <small *ngIf="record.new_status==3"><i class="text-danger fa fa-exclamation-triangle mr-2"></i>(Scartata)</small>
                    <small *ngIf="record.new_status==4"><i class="text-primary fa fa-check mr-2"></i>(Confermata)</small>
                    <small *ngIf="record.new_status==5"><i class="text-success fa fa-check-double mr-2"></i>(Accettata da PA)</small>
                    <small *ngIf="record.new_status==6"><i class="text-danger fa fa-exclamation-triangle mr-2"></i>(Rifiutata da PA)</small>
                </td>
                 <td class="status-{{record.old_status}}">
                    <small *ngIf="record.old_status==1"><i class="text-warning fa fa-clock mr-2"></i>(Inviata)</small>
                    <small *ngIf="record.old_status==2"><i class="text-success fa fa-check mr-2"></i>(Consegnata)</small>
                    <small *ngIf="record.old_status==3"><i class="text-danger fa fa-exclamation-triangle mr-2"></i>(Scartata)</small>
                    <small *ngIf="record.old_status==4"><i class="text-primary fa fa-check mr-2"></i>(Confermata)</small>
                    <small *ngIf="record.old_status==5"><i class="text-success fa fa-check-double mr-2"></i>(Accettata da PA)</small>
                    <small *ngIf="record.old_status==6"><i class="text-danger fa fa-exclamation-triangle mr-2"></i>(Rifiutata da PA)</small>
                </td>
                <td class="text-center">
                    <ng-container *ngIf="!record.change && record.new_status==3">
                        <span class="badge badge-warning">No</span>
                        <i title="Il documento risulta regolarmente consegnato con un altro invio" class="fas fa-question ml-2"></i>
                    </ng-container>
                    <span *ngIf="record.id>0 && record.change" class="badge badge-success" title="Lo stato del documento è stato correttamente sincronizzato">Sì</span>
                </td>
                <td class="text-right">
                    <small>{{record.sdi_invoice_new}}</small>                    
                </td>
            </tr>
        </table>        
    </ng-container>
</div>
<div class="modal-footer">        
    <button class="btn btn-outline-secondary" (click)="cancel()"><i class="fas fa-times mr-1"></i>Chiudi</button>
</div>